import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M13.277 17.08a7.35 7.35 0 0 1-3.428.62c-3.624-.24-6.562-3.151-6.828-6.78C2.7 6.6 6.085 3 10.311 3c4.043 0 8.03 2.687 7.093 9.101-.28 1.955-1.595 2.827-2.56 3.193-1.623.605-2.407-1.632-.406-1.49 1.609.112 5.05 4.079 6.352 5.64a.89.89 0 0 1-.042 1.196l-.07.084a.89.89 0 0 1-1.273.014l-3.806-4.08"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M8.196 14.919S4.588 13.123 5.8 8.045"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const SearchIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
